import {FirebaseAnalytics} from '@capacitor-community/firebase-analytics';
import store from '@/store/index.js';

/**
 * 設定使用者ID
 * @param {String} username 檔案在cdn的路徑
 */
export const setUserId = (username) => {
  if (!window.isApp) return;
  FirebaseAnalytics.setUserId({
    userId: username ? window.btoa(username) : null,
  });
};

/**
 * 設定使用者屬性
 * @param {String} key key
 * @param {String} value value
 */
export const setUserProperty = (key, value) => {
  if (!window.isApp) return;
  FirebaseAnalytics.setUserProperty({
    name: key,
    value,
  });
};

/**
 * setScreenName
 * @param {String} name name
 */
export const setScreenName = (name) => {
  if (!window.isApp) return;
  FirebaseAnalytics.setUserProperty({
    screenName: name,
  });
};

/**
 * setScreenName
 * @param {String} type type
 */
export const selectContent = (type, ...names) => {
  const locale = store.state.env.locale || 'zh-TW';
  let lang = '繁體中文';
  if (locale === 'zh-CN') {
    lang = '简体中文';
  } else if (locale === 'en-US') {
    lang = '英文';
  }
  if (!window.isApp) return;

  FirebaseAnalytics.logEvent({
    name: 'select_content',
    params: {
      lang,
      content_type: type, // 參考下方文件，不同事件有不同參數
      content_name: names[0], // 參考下方文件，不同事件有不同參數
      subcontent_name: names[1], // 參考下方文件，不同事件有不同參數
      subcontent2_name: names[2], // 參考下方文件，不同事件有不同參數
      // https://docs.google.com/presentation/d/1Ft1r0oIEcvQW61BPiKq87imYrMp8DTKEDjqUnOjnB-Q/edit#slide=id.g2f9159474ce_1_19
    },
  });
};

/**
 * productEvent
 * @param {event} event event
 * @param {product} product product
 */
export const productEvent = (event, product) => {
  if (!window.isApp) return;
  const locale = store.state.env.locale || 'zh-TW';
  let itemBrand = null;
  let itemCategory = null;
  switch (locale) {
    case 'zh-TW':
      itemCategory = '中文版';
      break;
    case 'en-US':
      itemCategory = '英文版';
      break;
    case 'ja-JP':
      itemCategory = '日文版';
      break;
    case 'zh-CN':
      itemCategory = '簡體版';
      break;
  }
  if (product.isItp) {
    itemBrand = '師資培訓';
  } else if (product.isVerification) {
    itemBrand = '模擬檢定';
  } else if (product.isAiTutor) {
    itemBrand = 'VIP方案';
  } else if (product.type === 'hjjCoursePlan') {
    itemBrand = '一般課程';
  } else if (product.type === 'physicalGood') {
    itemBrand = '實體商品';
  } else if (product.type === 'bundle') {
    itemBrand = '組合方案';
  }
  const currency = 'NTD'; // 換成台幣
  const price = product.price[currency].sellPrice;

  FirebaseAnalytics.logEvent({
    name: event,
    params: {
      currency,
      value: price,
      items: [
        {
          item_id: product.id, // 產品ID，中英文產品一樣
          item_name: product.name, // 產品名稱，中英文產品一樣，統一使用中文產品名稱
          item_brand: itemBrand, // 產品類別，如:一般課程,組合方案，中英文產品一樣，統一使用中文產品名稱
          item_category: itemCategory, // 區分中文/英文產品，如:中文版, 英文版
          price, // 產品販售價格
          quantity: 1, // 產品數量
        },
      ],
    },
  });
};

export default {
  setUserId,
  setUserProperty,
  setScreenName,
  selectContent,
  productEvent,
};
